import { Divider } from '@nextui-org/react';
import styled from 'styled-components';

import ZIndexLayers from '../../services/ZIndexLayers';
import { ThemeProp } from '../../theme/Themes';
import Link from '../Link';

export const TabsInnerContainer = styled.div`
  overflow-x: auto;
  position: relative;
  width: 100%;
  flex-wrap: nowrap;
  display: flex;

  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
    height: 0px;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
  margin-bottom: 1rem;
`;

export const TabContainer = styled.div`
  width: 100%;
`;

export const Tab = styled(Link).attrs((props) => {
  const isActive = props.status === 'active';
  const color = isActive ? props.theme.colors.primary.c100 : props.theme.colors.primary.c300;
  return {
    ...props,
    css: {
      ...props.css,
      '&': {
        ...props.css?.['&'],
        color,
        padding: '0rem 1rem',
        marginRight: '.5rem',
        fontWeight: isActive ? props.theme.fontWeight.semibold : props.theme.fontWeight.regular,
        fontSize: !props.isLinkTabs ? props.theme.fontSize.ml : props.theme.fontSize.s,
        zIndex: '2',
        whiteSpace: 'nowrap',
        stroke: color,
      },
    },
  };
})`
  ${(props) => !props.isLinkTabs && 'display: flex;'}
  ${(props) => !props.isLinkTabs && 'justify-content: center;'}
  ${(props) => !props.isLinkTabs && 'min-width: 100%;'}

  ${(props) => (props.status === 'active' ? `background-color: ${props.theme.colors.primary.c800}` : '')};
  border-radius: 0.25rem;

  svg {
    margin: auto 0.5rem auto 0;
  }
`;

export const Title = styled.div`
  margin: auto 0;
  padding: 0.5rem 0;
`;

export const ScrollHint = styled.div`
  position: absolute;
  bottom: 2px;
  right: 0;
  width: 1.5rem;
  height: 100%;
  z-index: ${ZIndexLayers.elevateOne};
  background: linear-gradient(270deg, #f9f9fe 26.37%, rgba(249, 249, 254, 0) 100%);

  @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.minMobile}) {
    display: none;
  }
`;

export const StyledDivider = styled(Divider)`
  margin-top: -1px;
`;

export const PageContainer = styled.div`
  width: 100%;
  padding: 2rem 5rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding: 1rem;
  }
`;
